module.exports = __webpack_public_path__ + "static/media/chatbubble-ellipses.1f8a0f98.svg";